<template>
  <div>
    <ul class="link link_myorder" v-show="loaded">
      <li><a class="box" @click="toMyDetail('myCard')">我的企业卡</a></li>
      <li><a class="box" @click="toMyDetail('mycoupon')">我的优惠券</a></li>
      <li><a class="box" @click="qimoChatClickyun()">意见反馈</a></li>
    </ul>
  </div>
</template>

<script>
  export default {
    props:{
      
      // radio:String,
      loaded:Boolean,
      // fl_stadium_list:Array,
    },
    data() {
      return {
  
      }
    },
    created() {},
    mounted() {
  
    },
    methods:{
      toMyDetail(item){
        this.$emit('toMyDetail',item)
      },
      qimoChatClickyun(){
        this.$emit('qimoChatClickyun')
      }
      // toCreateOrder(){
      //   this.$emit('toCreateOrder')
      // },
      // toOpenVideo(){
      //   this.$emit('toOpenVideo')
      // },
      // toOpenDesc(){
      //   this.$emit('toOpenDesc')
      // }
    }
  }
</script>

<style lang="less" scoped="scoped">
  @vm_base: 1/750*100vw;
  .link {
    margin-top: 24*@vm_base;
    width: calc(100% - 64*@vm_base);
    margin-left: 32*@vm_base;
    padding: 0 32*@vm_base;
    overflow: auto;
    background: rgba(255, 255, 255, 1);
    box-shadow: 0px 4px 20px 0px rgba(238, 238, 238, 1);
    border-radius: 12px;
  
    li {
      // margin-bottom:40*@vm_base;
      height: 100*@vm_base;
      line-height: 100*@vm_base;
      font-size: 28*@vm_base;
      color: #333333;
      font-weight: 400;
    }
  
    .box {
      display: block;
      background: url(../../assets/images/base/icon_arrow.png) right center no-repeat;
      background-size: 24*@vm_base auto;
      overflow: auto;
      font-size: 28*@vm_base;
      line-height: 100*@vm_base;
      font-weight: 400;
      color: rgba(51, 51, 51, 1);
    }
  
    .icon {
      float: left;
      width: 60*@vm_base;
      height: 60*@vm_base;
      margin-right: 20*@vm_base;
      background-size: 60*@vm_base auto;
      background-repeat: no-repeat;
      background-position: center center;
    }
  
    .i1 {
      background-image: url(../../assets/images/base/icon_i1N.png);
      border: 1px solid #000000;
      border-radius: 50%;
    }
  
    .i2 {
      background-image: url(../../assets/images/base/icon_i2N.png);
      border: 1px solid #000000;
      border-radius: 50%;
    }
  
    .i3 {
      background-image: url(../../assets/images/base/icon_i3N.png);
      border: 1px solid #000000;
      border-radius: 50%;
    }
  
    .tel {
      float: right;
      line-height: 60*@vm_base;
      margin-right: 30*@vm_base;
      font-size: 24*@vm_base;
      font-weight: 300;
      color: rgba(153, 153, 153, 1);
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/subgroup/myPanelFunctionLink.vue